import React, { useEffect, useState } from "react";
import { BOOKING_DETAILS_ZONE_TIME_FORMAT } from "../../../utils/helper";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";
import { Button } from "antd";
import { TranslateText } from "../../../utils/translation";

import {
  updateDisplayRoomDrawer,
  updateShowPrimaryGuestDrawer,
} from "../../../reducer/bookingReducer";
import PrimaryGuest from "./PrimaryGuest/PrimaryGuest";
import {
  calculateNumberOfNights,
  roomCountArrayObject,
  totalRoomsArray,
} from "../../../utils/bookingDetailsHelper";
import { getGuestsCount } from "../../../hooks/bookingCustomHook/useGetBookingList";
import moment from "moment";
import useGetBookingListLogic from "../../../hooks/bookingCustomHook/useGetBookingList";

const CheckinDetails = ({ bookingType, isBookingAlterationAllowed }) => {
  const { loadingDetails, bookingDetails, showMainBookingDetailsDrawer,
    invoiceDetails
   } =
    useSelector((store) => store.booking);

  const dispatch = useDispatch();
  const { response } = useSelector((store) => store.rooms);
  const { hotelDetails } = useSelector((store) => store.login);

  const [primaryGuestArray, setPrimaryGuestArray] = useState([]);

  const roomCountArray = roomCountArrayObject(bookingDetails, response);
  const totalRooms = totalRoomsArray(roomCountArray);
  const modifiedRoomCountArray = roomCountArray?.map((Obj) => {
    return {
      ...Obj,
      roomNum: Obj?.roomNum?.join(","),
    };
  });

  useEffect(() => {
    if (bookingDetails) {
      let primaryArray = Array.isArray(bookingDetails?.guests)
        ? bookingDetails?.guests?.filter((item) => Boolean(item))
        : [];
      setPrimaryGuestArray(primaryArray);
    }
  }, [bookingDetails]);

  const handleEditRoom = () => {
    if (!isBookingAlterationAllowed) return;

    dispatch(updateDisplayRoomDrawer());
  };

  const night = calculateNumberOfNights(
    bookingDetails?.checkIn,
    bookingDetails?.checkOut,
    hotelDetails
  );
  const {zoneOffset} = hotelDetails || '+05:30';
  const guestCount = getGuestsCount({invoices:invoiceDetails},bookingDetails?.id)
  return (
    <div className="  no-scrollbar no-scrollbar::-webkit-scrollbar">
      {loadingDetails ? (
        <div className="flex items-center justify-center">
          <CircularProgress size={32} sx={{ color: "#007FFF" }} />
        </div>
      ) : (
        <div className="font-outfit no-scrollbar::-webkit-scrollbar no-scrollbar flex flex-col gap-[0px]">
          <div className="p-4  flex flex-col gap-[12px]">
            <div className="flex justify-between items-center">
              <span className=" font-[500]  text-[18px] leading-[22.68px] text-[#222B45]">
                Booking details
              </span>

              {isBookingAlterationAllowed ? (
                <Button
                  onClick={handleEditRoom}
                  className="border-0  font-[500] text-[14px] leading-[20px] text-[#007FFF]"
                >
                  <TranslateText textKey={"edit_upgrade"} namespace="booking" />
                </Button>
              ) : (
                <></>
              )}
            </div>

            <div className="p-4 flex flex-col bg-[#F9FBFC] rounded-[12px]">
              <div className="uppercase text-[12px] leading-[18px] tracking-[1px] font-[600] text-[#8F9BB3] flex justify-between items-center">
                <p>Check-In</p>
                <p>Check-Out</p>
              </div>

              <div className="flex justify-between  text-[16px] font-[500]  leading-[28px] text-[#222B45] ">
                <span>
                  {Boolean(bookingDetails?.checkIn)
                    ? moment(bookingDetails?.checkIn).utcOffset(zoneOffset)?.format(
                        "ddd, DD MMM YYYY"
                      )
                    : ""}
                </span>

                <div className="flex justify-center items-center  w-[33%]">
                  <div
                    className="w-[5rem] flex justify-center items-center h-[2rem] 
                   rounded-lg bg-[#8F9BB3] text-[0.75rem] text-[#FFF] font-[500] "
                  >
                    {night} Night
                  </div>
                </div>

                <span>
                  {Boolean(bookingDetails?.checkOut)
                    ? moment(bookingDetails?.checkOut)?.utcOffset(zoneOffset)?.format(
                        "ddd, DD MMM YYYY"
                      )
                    : ""}
                </span>
              </div>

              <div className="flex justify-between  items-center text-[12px] font-[400] text-[#222B45]">
                <p>
                  From {BOOKING_DETAILS_ZONE_TIME_FORMAT({
                    date:bookingDetails?.checkIn,
                  zoneOffset  })}
                </p>

                <p>
                  By {BOOKING_DETAILS_ZONE_TIME_FORMAT(
                    {date:bookingDetails?.checkOut, zoneOffset})}
                </p>
              </div>

              <hr className="w-[100%] my-3 border-[#DCE2ED] " />

              <div className="font-[500] text-[16px] pb-[12px] text-[#222B45] leading-[20px]">
                {totalRooms?.length} Room for{" "}
                {guestCount?.A <= 1
                  ? `${guestCount?.A} adult`
                  : `${guestCount?.A} adults`}
                {guestCount?.C > 0 && (
                  <span>
                    {" and "}
                    {guestCount?.C === 1
                      ? `${guestCount?.C} child`
                      : `${guestCount?.C} children`}
                  </span>
                )}
              </div>

              <div className="flex flex-col items-start w-[100%] text-[#667085]">
                <div className="flex flex-col items-start justify-center   ">
                  {modifiedRoomCountArray?.map((room) => (
                    <div
                      key={room.type}
                      className=" text-[16px] font-[400] flex items-start gap-2 "
                    >
                      <span className="whitespace-nowrap">
                        {" "}
                        {room.count} X {room.type} &nbsp; -
                      </span>

                      <span className="tracking-[0.5px] break-all">
                        {room?.roomNum}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              <hr className="w-[100%] my-3 border-[#DCE2ED] " />

              <div className="flex justify-between items-center gap-4">
                <span className=" text-[16px] leading-[48px] font-[500] text-[#222B45]">
                  Meal Plan
                </span>
                <span className="text-[16px] leading-[20px] font-[500] text-[#007FFF]">
                  {bookingDetails?.mealPlan}
                </span>
              </div>
            </div>
          </div>

          <div className="p-4  flex flex-col gap-[16px]">
            <div className="flex justify-between items-center">
              <span className=" font-[500]  text-[18px] leading-[22.68px] text-[#222B45]">
                Guest Details
              </span>

              {isBookingAlterationAllowed && (
                <div
                  className="  text-[#2F80ED] font-outfit text-[14px] font-[500] flex justify-center items-center cursor-pointer"
                  onClick={() =>
                    dispatch(
                      updateShowPrimaryGuestDrawer({
                        visible: true,
                        bookingId: showMainBookingDetailsDrawer.bookingId,
                        customerType: "new",
                        customerId: "",
                      })
                    )
                  }
                >
                  Add New Guest
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2 bg-[#F9FBFC] p-4 rounded-[12px]">
              <PrimaryGuest
                isBookingAlterationAllowed={isBookingAlterationAllowed}
                primaryGuestArray={primaryGuestArray}
                bookingType={bookingType}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CheckinDetails;
